import networkErrorParser from './networkErrorParser';
import requestErrorParser from './requestErrorParser';
import validationErrorParser from './validationErrorParser';
import graphQLErrorParser from './graphQLErrorParser';

export default [networkErrorParser, requestErrorParser, validationErrorParser, graphQLErrorParser];
